// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.7f07633d.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"442":"14390c3f","514":"37ce7ceb"}[chunkId] + ".chunk.css";
};